module.exports = __webpack_public_path__ + "static/media/fly0171.31eaa1a3.webp";